document.addEventListener('DOMContentLoaded', function () {
  const grid = document.querySelector('.logo-grid');
  if (!grid) return;

  const items = grid.querySelectorAll('.logo-grid-image');
  const currentUrl = window.location.pathname;

  let hasActive = false;

  items.forEach(function (item) {
    const link = item.querySelector('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (href && currentUrl.startsWith(href)) {
      item.classList.add('is-active');
      hasActive = true;
    }
  });

  if (hasActive) {
    grid.classList.add('logo-grid--has-active');
  }
});
